export default __webpack_public_path__ + "static/media/espiritual.fad50757.jpg";